"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.agreementInfoApi = agreementInfoApi;
exports.agreementSaveApi = agreementSaveApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * @description 协议管理-- 详情
 */
function agreementInfoApi(data) {
  return _request.default.get("admin/platform/agreement/".concat(data));
}

/**
 * @description 协议管理-- 保存
 */
function agreementSaveApi(save, data) {
  // return request.post(`admin/platform/agreement/${save}`, data);
  return (0, _request.default)({
    url: "admin/platform/agreement/".concat(save),
    method: 'POST',
    data: data
  });
}